/**
 * Polyfills for missing functionality. Mostly IE.
 */

const
    isIE10 = navigator.appVersion.indexOf('MSIE 10') !== -1,
    isHighContrastMode = window.matchMedia('(-ms-high-contrast: active)').matches;

export function IEImageSupport() {
    /*
    * Selects IE10 and IE11
    */
    if ((!!window.MSInputMethodContext && !!document.documentMode) || isIE10) {
        /*
        *   IE11 does not support picture at all so picturefill to the rescue.
        */
        import(/* webpackChunkName: "picturefill" */ 'picturefill').then((picturefill) => {
            picturefill.default()
        }).catch(err => {
            console.error('Error during loading module: ' + err)
        });

        //Avoid setting this polyfill on high-contrast mode, as it turns images into background-images, which do not render in Windows High Contrast Mode.
        //You do get some warped images here and there, but that's better than no images.
        if (!isHighContrastMode) {
            /*
            *  There is also a postcss plugin to add the font-family declarations
            *  but at the time of writing it duplicates the values twice and hasn't
            *  been updated in years.
            */
            import(/* webpackChunkName: "polyfill-object-fit-images" */ 'object-fit-images').then((objectFitImages) => {
                let allImages = document.querySelectorAll('img'),
                    readyImages = document.querySelectorAll('img:not([data-image-component="ondemandload"])');

                objectFitImages.default(allImages, {watchMQ: true});

                //Only loop through images that aren't set to load on demand.
                [].forEach.call(readyImages, currentImage => currentImage.classList.add('lazyloaded'));
            });
        }
    }
}

/**
 * Provides a `format` method on String types.
 * This can be used to replace literals within a string, for example:
 * A string: "This is a {0} test, {1}.".format("good", "happy");
 * Will output: "This is a good test, happy."
 */
export function stringFormat() {
    if (!String.prototype.format) {
        String.prototype.format = function() {
            let string = this;

            for (let i = 0; i < arguments.length; i++) {
                string = string.replace(new RegExp('\\{' + i + '\\}', 'gm'), arguments[i]);
            }

            return string;
        };
    }
}

//Detecs if `:placeholder-shown` is supported, cause otherwise attempting to access it creates a silent error on some browsers.
export function supportsPlaceholderShown() {
    window.SFRA = window.SFRA || {};

    try {
        document.body.matches(':placeholder-shown');

        window.SFRA.supportsPlaceholderShown = true;
    } catch (e) {
        window.SFRA.supportsPlaceholderShown = false;
    }
}

export default function() {
    IEImageSupport();
    stringFormat();
    supportsPlaceholderShown();
}
